import {
  Button,
  ButtonProps,
  Flex,
  HStack,
  Heading,
  IconButton,
  StackProps,
  UseDisclosureReturn
} from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import Pathicon from "@pathwright/features/src/modules/pathicon/Pathicon"
import { ReactNode } from "react"
import Link, { LinkHref, LinkRelativeTo, LinkTo } from "../link/Link"

// TODO: rename this as CardLink is too specific.
// Component probably doesn't even belong in Card folder.

type CardLinkProps = {
  label: string
  icon?: IconName
  to?: LinkTo
  relativeTo?: LinkRelativeTo
  href?: LinkHref
  onClick?: () => void
  disclosure?: UseDisclosureReturn
  renderIcon?: () => ReactNode
} & StackProps &
  ButtonProps

function CardLink({
  label,
  icon,
  to,
  relativeTo,
  href,
  onClick,
  disclosure,
  renderIcon,
  ...stackButtonProps
}: CardLinkProps) {
  const hasLink = !!to || !!relativeTo || !!href

  const button = (
    <Button
      variant="ghost"
      pointerEvents="auto"
      minW={200}
      p={2}
      borderRadius="20px"
      _hover={{ bg: "blackAlpha.200" }}
      cursor="pointer"
      onClick={(e) => {
        onClick?.()
        disclosure?.onToggle()
      }}
    >
      <Flex align="center" gap={2}>
        {renderIcon ? renderIcon() : !!icon && <Pathicon icon={icon} />}
        <Heading
          minW={200}
          w="100%"
          as="h2"
          fontSize="sm"
          color="blackAlpha.900"
          m={0}
          textAlign="left"
        >
          {label}
        </Heading>
      </Flex>
      <Flex align="center">
        <IconButton
          as="div"
          aria-label="Toggle"
          variant="ghost"
          bg="none"
          colorPalette="blackAlpha"
          cursor="pointer"
          ml={2}
          h={8}
          minW={8}
          borderRadius="full"
        >
          <Pathicon
            icon={
              disclosure?.open
                ? "chevron-down"
                : href
                ? "external-link"
                : "chevron-right"
            }
          />
        </IconButton>
      </Flex>
    </Button>
  )

  return (
    <HStack
      asChild
      align="center"
      justify="space-between"
      w="100%"
      {...stackButtonProps}
    >
      {hasLink ? (
        <Link
          asChild
          to={to}
          relativeTo={relativeTo}
          href={href}
          variant="plain"
          _hover={{ textDecoration: "none" }}
        >
          {button}
        </Link>
      ) : (
        button
      )}
    </HStack>
  )
}

export default CardLink
